const useStyles = theme => ({
  miniCarousel: {
    position: 'relative',
  },
  titlesContainer: {
    paddingTop: 20,
    paddingRight: 5,
    marginLeft: 2,
    height: 140,
  },
  mainTitle: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-word",
    overflow: "hidden",
  },
  secondaryTitle: {
    marginLeft: 2,
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    height: 46,
    wordBreak: "break-word",
    marginTop: 15,
  },
});

export default useStyles
